import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ellipsis',
    standalone: true,
})
export class EllipsisPipe implements PipeTransform {
  transform(value: string, limit: number): any {
    if (value === null || value === undefined) {
      return value;
    }
    const words = value.split(' ');
    if (limit && words.length > limit) {
      return words.slice(0, limit).join(' ').concat('...');
    }
    return value;
  }
}
